import React, { useEffect, useState } from "react";
import LabImg from "../../../Assets/Icons/Lab.svg";
import { message, Modal, Select } from "antd";
import LabOrderService from "../../../Services/LabOrderService";

function ShareLab({
  labs,
  appointmentDetails,
  labOrders,
  setLabOrders,
  selectedLab,
  setSelectedLab,
}) {
  const [labList, setLabList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [save, setSave] = useState(false);
  const [loading, setLoading] = useState(false);

  const showLabModal = async () => {
    if (labs.length === 0) {
      message.error("Add Labs in consultation to share order");
      return;
    }
    setLoading(true);

    try {
      let payload = {
        userId: appointmentDetails.userId,
        status: 1,
      };

      let res = await LabOrderService.GetLabList(payload);
      setLabList(res.data);
      setIsModalOpen(true);
    } catch (error) {
      message.error("Error");
    } finally {
      setLoading(false);
    }
  };

  const handleLabSelect = (selectedId) => {
    const selectedObj = labList.find((item) => item.id === selectedId);
    setSelectedLab(selectedObj);
  };

  const onLabOrderSend = () => {
    message.info(
      "Lab Order triggered, order will be sent when consultation ends",
    );
    setLabOrders(true);
    setIsModalOpen(false);
  };

  const handleCancelOrder = () => {
    setLabOrders(false);
    setSelectedLab(null);
    message.info("Lab Order cancelled");
  };
  useEffect(() => {
    if (labs.length == 0) {
      setLabOrders(false);
      setSelectedLab(null);
    }
  }, [labs]);


  return (
    <>
      {loading && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <div className="relative flex " title="Lab Order">
        <div
          onClick={showLabModal}
          className={`w-[28px] h-[28px] flex items-center justify-center rounded-full transition-all duration-300 ${labs.length > 0
            ? "bg-brand-primaryColor text-white"
            : "bg-[#E1E1E1]"
            }`}
        >
          <img
            src={LabImg}
            alt="Lab"
            className={`transition-all duration-300 ${labs.length > 0 ? "filter invert fill-white" : ""
              }`}
          />
        </div>

        {/* 🔴 Badge (top-right) */}
        {labOrders && labs.length > 0 && (
          <div
            onClick={handleCancelOrder}
            className="absolute -top-1 -right-1 
                       w-5 h-5 
                       flex items-center justify-center 
                       text-[10px] font-bold 
                       bg-rose-500 text-white 
                       rounded-full 
                       shadow-md
                       cursor-pointer 
                       hover:bg-rose-600 
                       transition-all duration-200"
          >
            ✕
          </div>
        )}
      </div>
      {/* 🔥 Modal */}
      <Modal
        title="Lab Order"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[]}
      >
        {save && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}

        <div className="flex gap-2">
          <Select
            className="w-[80%]"
            value={selectedLab?.id}
            onChange={handleLabSelect}
            placeholder="Select Lab"
          >
            {labList?.map((lab) => (
              <Select.Option key={lab.id} value={lab.id}>
                {lab.labName}
              </Select.Option>
            ))}
          </Select>

          <button
            onClick={onLabOrderSend}
            className="p-1 rounded-md bg-[24,159,170] text-white font-semibold"
            disabled={save}
          >
            Order
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ShareLab;
